import script from "./FeatureVideos.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeatureVideos.vue?vue&type=script&setup=true&lang=ts"

import "./FeatureVideos.vue?vue&type=style&index=0&id=4479c9a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4479c9a2"]])

export default __exports__